import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-relations-readonly',
  imports: [],
  templateUrl: './relations-readonly.component.html',
  styleUrl: './relations-readonly.component.scss'
})
export class RelationsReadonlyComponent {
  @Input() relationsInfo: any;
}
